import React, { useState } from "react";
import { Box, Flex, Text, Spacer } from "@chakra-ui/react";

type DayOfWeekProps = {
  day: string;
  content: any[];
};

export const DayOfWeek: React.FC<DayOfWeekProps> = ({ day, content }) => {
  const [isBoxVisible, setIsBoxVisible] = useState(false);

  const toggleBoxes = () => {
    setIsBoxVisible((prevState) => !prevState);
  };

  return (
    <Box>
      <Box onClick={toggleBoxes}>{day}</Box>

      {isBoxVisible && (
        <>
          {content.map((item, index) => (
            <Box key={index}>
              <Flex>
                <Text color="gray.400">{item.label}: </Text>
                <Spacer />
                <Text>{item.value}</Text>
              </Flex>
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};
